(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["tcc-block-slider"] && !Shopify.designMode) return;
  try {
    
    (function() {
        var section = document.querySelector('[data-recommendations]');
        if (!section) return;

        var productId = section.dataset.productId;
        var limit     = section.dataset.limit || 4;
        var sectionId = section.dataset.sectionId;

        var url =
        '/recommendations/products?section_id=' + sectionId +
        '&product_id=' + productId +
        '&limit=' + limit;

        fetch(url)
        .then(function(res) { return res.text(); })
        .then(function(html) {
            var parser = new DOMParser();
            var doc    = parser.parseFromString(html, 'text/html');
            var inner  = doc.querySelector('.product-recommendations');
            if (inner) section.innerHTML = inner.innerHTML;
        });
    })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tcc-collections"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('tcc-collection-page')) {
    customElements.define('tcc-collection-page', class extends HTMLElement {
      connectedCallback() {
        this.sectionId = this.dataset.sectionId;
        this.dialog = this.querySelector('[data-tcc-drawer]');
        this.form = this.querySelector('[data-tcc-filter-form]');
        this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        this.onClick = this.onClick.bind(this);
        this.onChange = this.onChange.bind(this);
        this.onInput = this.onInput.bind(this);
        this.onSubmit = (e) => { e.preventDefault(); this.close(); };
        this.onCancel = (e) => { e.preventDefault(); this.close(); };
        this.onPop = () => {
          if (this.filterMode()) this.useCategoryFromUrl();
          this.render(new URLSearchParams(location.search), false);
        };
        this.onQuickView = (e) => {
          // Runs last (document, bubble). If the theme's quick view handled the click it will have
          // called preventDefault; otherwise send the shopper to the product page instead of a dead button.
          const b = e.target.closest('[data-quick-shop-trigger="quick-view"][data-product-url]');
          if (!b || !this.contains(b) || e.defaultPrevented) return;
          location.href = b.dataset.productUrl;
        };

        this.canHover = window.matchMedia('(hover: hover)').matches;
        this.onOver = (e) => {
          const sw = e.target.closest('[data-tcc-swatch]');
          if (this.canHover && sw && !sw.contains(e.relatedTarget)) this.swatch(sw, false);
        };
        this.onOut = (e) => {
          const sw = e.target.closest('[data-tcc-swatch]');
          if (this.canHover && sw && !sw.contains(e.relatedTarget)) this.restoreCard(sw.closest('[data-tcc-card]'));
        };
        this.onKey = (e) => {
          if (e.key !== 'Escape') return;
          const qa = e.target.closest && e.target.closest('[data-tcc-qa].is-open');
          if (qa) { this.closeQuickAdd(qa); qa.querySelector('[data-tcc-qa-open]').focus(); }
        };
        this.onDocClick = (e) => {
          this.querySelectorAll('[data-tcc-qa].is-open').forEach((qa) => { if (!qa.contains(e.target)) this.closeQuickAdd(qa); });
        };
        this.addEventListener('keydown', this.onKey);
        document.addEventListener('click', this.onDocClick);
        this.addEventListener('mouseover', this.onOver);
        this.addEventListener('mouseout', this.onOut);
        this.addEventListener('click', this.onClick);
        this.addEventListener('change', this.onChange);
        this.addEventListener('input', this.onInput);
        if (this.form) this.form.addEventListener('submit', this.onSubmit);
        if (this.dialog) this.dialog.addEventListener('cancel', this.onCancel);
        window.addEventListener('popstate', this.onPop);
        if (this.dataset.quickViewFallback === 'true') document.addEventListener('click', this.onQuickView);

        this.bindPagination();
        // A shared / reloaded link with ?category= : the server sent this collection, so load the category's grid.
        this.catHandle = '';
        if (this.filterMode()) {
          this.useCategoryFromUrl();
          if (this.catHandle) this.render(new URLSearchParams(location.search), false);
        }
        this.revealActiveCategory();
      }

      revealActiveCategory() {
        const list = this.querySelector('.tcc-cp__cats-list');
        const active = list && list.querySelector('.tcc-cp__cat.is-active');
        if (!active || list.scrollWidth <= list.clientWidth) return;
        const item = active.parentElement;
        list.scrollLeft = item.offsetLeft - (list.clientWidth - item.offsetWidth) / 2;
      }

      disconnectedCallback() {
        this.removeEventListener('keydown', this.onKey);
        document.removeEventListener('click', this.onDocClick);
        this.removeEventListener('mouseover', this.onOver);
        this.removeEventListener('mouseout', this.onOut);
        this.removeEventListener('click', this.onClick);
        this.removeEventListener('change', this.onChange);
        this.removeEventListener('input', this.onInput);
        window.removeEventListener('popstate', this.onPop);
        document.removeEventListener('click', this.onQuickView);
        if (this.observer) this.observer.disconnect();
        clearTimeout(this.debounce);
        document.documentElement.classList.remove('tcc-cp-lock');
      }

      open() {
        if (!this.dialog || this.dialog.open) return;
        this.dialog.showModal();
        document.documentElement.classList.add('tcc-cp-lock');
      }

      close() {
        if (!this.dialog || !this.dialog.open) return;
        const done = () => {
          this.dialog.classList.remove('is-closing');
          this.dialog.close();
          document.documentElement.classList.remove('tcc-cp-lock');
        };
        if (this.reduced) return done();
        this.dialog.classList.add('is-closing');
        setTimeout(done, 240);
      }

      onClick(e) {
        if (e.target === this.dialog) return this.close();
        const sw = e.target.closest('[data-tcc-swatch]');
        if (sw) return this.swatch(sw, true);
        const cat = e.target.closest('[data-tcc-cat]');
        if (cat) {
          const nav = cat.closest('[data-tcc-cats]');
          if (nav && nav.dataset.click === 'link') return; // normal link: open the collection page
          e.preventDefault();
          return this.selectCategory(cat);
        }
        const qaOpen = e.target.closest('[data-tcc-qa-open]');
        if (qaOpen) return this.openQuickAdd(qaOpen.closest('[data-tcc-qa]'));
        const qaClose = e.target.closest('[data-tcc-qa-close]');
        if (qaClose) return this.closeQuickAdd(qaClose.closest('[data-tcc-qa]'));
        const qaOpt = e.target.closest('[data-tcc-qa-variant]');
        if (qaOpt) return this.addToCart(qaOpt.closest('[data-tcc-qa]'), qaOpt.dataset.tccQaVariant, qaOpt);
        const t = e.target.closest('[data-tcc-open], [data-tcc-close], [data-tcc-filter-link], [data-tcc-load-more]');
        if (!t) return;
        if (t.hasAttribute('data-tcc-open')) return this.open();
        if (t.hasAttribute('data-tcc-close')) { e.preventDefault(); return this.close(); }
        e.preventDefault();
        if (t.hasAttribute('data-tcc-load-more')) return this.loadMore();
        this.render(new URL(t.href, location.origin).searchParams);
      }

      onChange(e) {
        const t = e.target;
        if (t.matches('[data-tcc-price]')) return this.queue(0);
        if (t.matches('[data-tcc-sort]') || (this.form && this.form.contains(t))) this.render(this.formParams());
      }

      onInput(e) {
        if (e.target.matches('[data-tcc-price]')) this.queue(700);
      }

      queue(ms) {
        clearTimeout(this.debounce);
        this.debounce = setTimeout(() => this.render(this.formParams()), ms);
      }

      formParams() {
        const params = new URLSearchParams();
        if (!this.form) return params;
        for (const [k, v] of new FormData(this.form)) {
          if (typeof v === 'string' && v.trim() !== '') params.append(k, v.trim());
        }
        return params;
      }

      sectionUrl(params, id) {
        const p = new URLSearchParams(params);
        p.delete('category');
        p.set('section_id', id || this.gridSectionId || this.sectionId);
        return `${this.catHandle ? this.catPath : location.pathname}?${p.toString()}`;
      }

      async fetchDoc(url) {
        if (this.controller) this.controller.abort();
        this.controller = new AbortController();
        const res = await fetch(url, { signal: this.controller.signal });
        if (!res.ok) throw new Error(res.status);
        return new DOMParser().parseFromString(await res.text(), 'text/html');
      }

      clean(root) {
        root.querySelectorAll('a[href*="section_id"]').forEach((a) => {
          const u = new URL(a.getAttribute('href'), location.origin);
          u.searchParams.delete('section_id');
          a.setAttribute('href', u.pathname + (u.search || ''));
        });
      }

      async render(params, push = true) {
        params = new URLSearchParams(params);
        params.delete('page');
        params.delete('section_id');
        params.delete('category');
        if (this.catHandle) params.set('category', this.catHandle);
        const qs = params.toString();
        this.classList.add('is-loading');
        try {
          const doc = await this.fetchGrid(params);
          const activeId = document.activeElement && this.contains(document.activeElement) ? document.activeElement.id : '';

          const nextResults = doc.querySelector('[data-tcc-results]');
          const results = this.querySelector('[data-tcc-results]');
          if (nextResults && results) results.innerHTML = nextResults.innerHTML;

          const nextFilters = doc.querySelector('[data-tcc-filters]');
          const filters = this.querySelector('[data-tcc-filters]');
          if (nextFilters && filters) {
            const scroll = filters.querySelector('.tcc-cp__drawer-body')?.scrollTop || 0;
            const openKeys = [...filters.querySelectorAll('details[open]')].map((d) => d.dataset.key);
            filters.innerHTML = nextFilters.innerHTML;
            filters.querySelectorAll('details[data-key]').forEach((d) => {
              if (openKeys.includes(d.dataset.key)) d.open = true;
            });
            const body = filters.querySelector('.tcc-cp__drawer-body');
            if (body) body.scrollTop = scroll;
          }

          this.clean(this);
          // A grid rendered by file name carries that render's ids; point its controls at this page's form/drawer.
          const sortSel = this.querySelector('[data-tcc-sort]');
          if (sortSel && this.form) sortSel.setAttribute('form', this.form.id);
          const openBtn = this.querySelector('[data-tcc-open]');
          if (openBtn && this.dialog) openBtn.setAttribute('aria-controls', this.dialog.id);
          if (activeId) {
            const el = this.querySelector(`#${CSS.escape(activeId)}`);
            if (el) el.focus({ preventScroll: true });
          }
          if (push) history.pushState({ tcc: this.sectionId }, '', `${location.pathname}${qs ? `?${qs}` : ''}`);
          this.bindPagination();
          this.rebindTheme();
          this.notify('filter', [...this.querySelectorAll('[data-tcc-grid] > *')]);
        } catch (err) {
          if (err.name === 'AbortError') return;
          if (this.catHandle) { console.warn('TCC collection: category grid failed to load. Check the Section file name setting.', err); return; }
          location.href = `${location.pathname}${qs ? `?${qs}` : ''}`;
        } finally {
          this.classList.remove('is-loading');
        }
      }

      rebindTheme() {
        // theme.js binds product-item buttons once per section instance (ProductItem), so cards added by
        // filtering / load more need the instance rebuilt. Uses the theme's public @shopify/theme-sections registry.
        if (this.dataset.sectionType !== 'collection') return;
        const S = window.Shopify && window.Shopify.theme && window.Shopify.theme.sections;
        if (!S || !S.registered || !S.registered.collection || !S.instances) return;
        const i = S.instances.findIndex((inst) => inst.container === this);
        if (i > -1) {
          try { S.instances[i].onUnload(); } catch (err) { /* stale instance */ }
          S.instances.splice(i, 1);
        }
        try {
          S.instances.push(new S.registered.collection(this));
        } catch (err) {
          console.warn('TCC collection: theme product card init failed', err);
        }
      }

      // ── Categories: reload the grid with a sub-collection's products, without leaving the page ──
      // The grid is fetched from the sub-collection (/collections/hoops) with the Section Rendering API:
      // first with this section's id (works when Hoops uses the same template), otherwise with the section
      // file name (works with any template). The address bar stays on this collection: ?category=hoops.

      selectCategory(link) {
        const handle = link.dataset.handle || '';
        if (handle === this.catHandle) return;
        this.catHandle = handle;
        this.catPath = handle ? link.dataset.path : '';
        this.setActiveCategory(link);
        // Filter values and sort differ per collection, so a new category starts clean.
        const params = new URLSearchParams(location.search);
        [...params.keys()].filter((k) => k.startsWith('filter.') || k === 'sort_by').forEach((k) => params.delete(k));
        return this.render(params, true);
      }

      filterMode() {
        const nav = this.querySelector('[data-tcc-cats]');
        return !!nav && nav.dataset.click !== 'link';
      }

      setActiveCategory(link) {
        this.querySelectorAll('[data-tcc-cat]').forEach((a) => {
          const on = a === link;
          a.classList.toggle('is-active', on);
          if (on) a.setAttribute('aria-current', 'true'); else a.removeAttribute('aria-current');
        });
      }

      useCategoryFromUrl() {
        const nav = this.querySelector('[data-tcc-cats]');
        const handle = new URLSearchParams(location.search).get('category') || '';
        const links = nav ? [...nav.querySelectorAll('[data-tcc-cat]')] : [];
        const link = links.find((a) => (a.dataset.handle || '') === handle) || links.find((a) => !a.dataset.handle);
        this.catHandle = link ? link.dataset.handle || '' : '';
        this.catPath = this.catHandle ? link.dataset.path : '';
        if (link) this.setActiveCategory(link);
      }

      async fetchGrid(params) {
        if (!this.catHandle) {
          this.gridSectionId = this.sectionId;
          return this.fetchDoc(this.sectionUrl(params, this.sectionId));
        }
        this.catIds = this.catIds || {};
        const known = this.catIds[this.catHandle];
        const ids = known ? [known] : [this.sectionId, this.dataset.sectionFile];
        let lastErr;
        for (const id of ids) {
          try {
            const doc = await this.fetchDoc(this.sectionUrl(params, id));
            if (!doc.querySelector('[data-tcc-results]')) throw new Error('no grid in response');
            this.catIds[this.catHandle] = id;
            this.gridSectionId = id;
            return doc;
          } catch (err) {
            if (err.name === 'AbortError') throw err;
            lastErr = err;
          }
        }
        throw lastErr;
      }

      setImage(card, src, srcset) {
        const img = card && card.querySelector('.tcc-cp__img--primary');
        if (!img || !src) return;
        if (srcset) img.setAttribute('srcset', srcset); else img.removeAttribute('srcset');
        img.setAttribute('src', src);
        img.loading = 'eager';
      }

      swatch(btn, commit) {
        // Preview (hover) or select (click) a color: swap the card image, and on select also link + price.
        const card = btn.closest('[data-tcc-card]');
        if (!card) return;
        const img = card.querySelector('.tcc-cp__img--primary');
        if (img && !card.tccOrig) card.tccOrig = { src: img.getAttribute('src'), srcset: img.getAttribute('srcset') || '' };
        if (btn.dataset.src) this.setImage(card, btn.dataset.src, btn.dataset.srcset);
        if (!commit) return;
        card.querySelectorAll('[data-tcc-swatch]').forEach((b) => b.setAttribute('aria-pressed', String(b === btn)));
        card.querySelectorAll('[data-tcc-link]').forEach((a) => { a.href = btn.dataset.url; });
        const price = card.querySelector('[data-tcc-price]');
        if (price && btn.dataset.price) price.innerHTML = btn.dataset.price;
        const media = card.querySelector('.tcc-cp__card-media');
        if (media && btn.dataset.src) media.classList.remove('has-hover');
      }

      restoreCard(card) {
        if (!card || !card.tccOrig) return;
        const pressed = card.querySelector('[data-tcc-swatch][aria-pressed="true"]');
        if (pressed && pressed.dataset.src) return this.setImage(card, pressed.dataset.src, pressed.dataset.srcset);
        this.setImage(card, card.tccOrig.src, card.tccOrig.srcset);
      }

      openQuickAdd(qa) {
        if (!qa) return;
        const json = qa.querySelector('[data-tcc-variants]');
        if (!json) return this.addToCart(qa, qa.dataset.variantId);

        if (!qa.tccVariants) {
          try { qa.tccVariants = JSON.parse(json.textContent); } catch (err) { qa.tccVariants = []; }
        }
        // Only show variants of the chosen color (selected swatch, else the default variant's color).
        let list = qa.tccVariants;
        const ci = qa.dataset.colorIndex;
        if (ci !== undefined && ci !== '') {
          const card = qa.closest('[data-tcc-card]');
          const pressed = card && card.querySelector('[data-tcc-swatch][aria-pressed="true"]');
          const color = pressed ? pressed.dataset.value : qa.dataset.defaultColor;
          list = list.filter((v) => v.o[Number(ci)] === color);
        }
        const available = list.filter((v) => v.a);
        if (list.length === 1 && available.length === 1) return this.addToCart(qa, list[0].id);

        const opts = qa.querySelector('[data-tcc-qa-opts]');
        const msg = qa.querySelector('[data-tcc-qa-msg]');
        opts.textContent = '';
        if (msg) msg.textContent = '';
        list.forEach((v) => {
          const b = document.createElement('button');
          b.type = 'button';
          b.className = 'tcc-cp__qa-opt';
          b.dataset.tccQaVariant = v.id;
          b.textContent = v.o.filter((_, i) => String(i) !== String(ci)).join(' / ') || v.o.join(' / ');
          if (!v.a) { b.disabled = true; b.setAttribute('aria-label', `${b.textContent} (sold out)`); }
          opts.appendChild(b);
        });
        this.querySelectorAll('[data-tcc-qa].is-open').forEach((o) => { if (o !== qa) this.closeQuickAdd(o); });
        qa.classList.add('is-open');
        qa.querySelector('[data-tcc-qa-open]').setAttribute('aria-expanded', 'true');
        qa.querySelector('[data-tcc-qa-panel]').hidden = false;
        const first = opts.querySelector('button:not(:disabled)') || qa.querySelector('[data-tcc-qa-close]');
        if (first) first.focus({ preventScroll: true });
      }

      closeQuickAdd(qa) {
        if (!qa) return;
        qa.classList.remove('is-open');
        const panel = qa.querySelector('[data-tcc-qa-panel]');
        if (panel) panel.hidden = true;
        const btn = qa.querySelector('[data-tcc-qa-open]');
        if (btn && btn.hasAttribute('aria-expanded')) btn.setAttribute('aria-expanded', 'false');
      }

      async addToCart(qa, id, optBtn) {
        if (!qa || !id || qa.classList.contains('is-busy')) return;
        const text = qa.querySelector('[data-tcc-qa-text]');
        const label = text ? text.textContent : '';
        const msg = qa.querySelector('[data-tcc-qa-msg]');
        qa.classList.add('is-busy');
        if (optBtn) optBtn.setAttribute('aria-busy', 'true');
        try {
          const res = await fetch(`${this.dataset.cartAdd}.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] })
          });
          const data = await res.json();
          if (!res.ok) throw new Error(data.description || data.message || this.dataset.errorLabel);

          if (this.dataset.afterAdd === 'cart') { location.href = this.dataset.cartUrl; return; }

          this.closeQuickAdd(qa);
          qa.classList.add('is-added');
          if (text) text.textContent = this.dataset.addedLabel;
          clearTimeout(qa.tccTimer);
          qa.tccTimer = setTimeout(() => { qa.classList.remove('is-added'); if (text) text.textContent = label; }, 2000);
          this.cartChanged(data);
        } catch (err) {
          const m = err.message || this.dataset.errorLabel;
          if (msg && qa.classList.contains('is-open')) msg.textContent = m;
          else window.alert(m);
        } finally {
          qa.classList.remove('is-busy');
          if (optBtn) optBtn.removeAttribute('aria-busy');
        }
      }

      async cartChanged(added) {
        // Open the store's custom cart drawer, plus a TCC event for anything else that needs to react.
        // bubbles: true so it also reaches listeners on window, not only on document.
        document.dispatchEvent(new Event('gOpenCart', { bubbles: true }));
        document.dispatchEvent(new CustomEvent('tcc:cart:added', { detail: { items: added && added.items, source: 'tcc-collection-page' } }));
        try {
          const cart = await (await fetch(`${this.dataset.cartUrl}.js`, { headers: { Accept: 'application/json' } })).json();
          document.querySelectorAll('[data-cart-count], .cart-count, .cart-count-bubble span[aria-hidden="true"], .js-cart-count, #CartCount').forEach((el) => {
            if (/^\s*\d*\s*$/.test(el.textContent)) { el.textContent = cart.item_count; el.hidden = false; }
          });
        } catch (err) { /* count update is best effort */ }
      }

      refreshReviews() {
        // Judge.me styles badges on page load; cards added by filtering / load more need it again.
        const j = window.jdgm;
        if (!j) return;
        ['customizeBadges', 'batchRenderBadges'].forEach((fn) => {
          if (typeof j[fn] === 'function') { try { j[fn](); } catch (err) { /* Judge.me API changed */ } }
        });
      }

      notify(reason, items) {
        this.refreshReviews();
        // Hook for theme scripts (quick add, swatches, reveal) to re-init on new products.
        document.dispatchEvent(new CustomEvent('tcc:collection:updated', { detail: { section: this, reason, items } }));
      }

      bindPagination() {
        if (this.observer) this.observer.disconnect();
        const btn = this.querySelector('[data-tcc-load-more]');
        if (!btn || this.dataset.pagination !== 'infinite' || !('IntersectionObserver' in window)) return;
        this.observer = new IntersectionObserver((entries) => {
          if (entries.some((en) => en.isIntersecting)) this.loadMore();
        }, { rootMargin: '0px 0px 400px 0px' });
        this.observer.observe(btn);
      }

      loadMore() {
        // Returns a promise; concurrent callers (scroll + category fill) share the same request.
        if (this.loadingMore) return this.loadingPromise;
        const btn = this.querySelector('[data-tcc-load-more]');
        if (!btn) return Promise.resolve(false);
        this.loadingMore = true;
        this.loadingPromise = this.fetchMore(btn).finally(() => { this.loadingMore = false; });
        return this.loadingPromise;
      }

      async fetchMore(btn) {
        btn.setAttribute('aria-busy', 'true');
        btn.textContent = btn.dataset.loadingLabel;
        const url = new URL(btn.href, location.origin);
        try {
          url.searchParams.set('section_id', this.gridSectionId || this.sectionId);
          const res = await fetch(url.toString());
          if (!res.ok) throw new Error(res.status);
          const doc = new DOMParser().parseFromString(await res.text(), 'text/html');

          const grids = this.querySelectorAll('[data-tcc-results] [data-tcc-grid]');
          const target = grids[grids.length - 1];
          const frag = document.createDocumentFragment();
          const added = [];
          doc.querySelectorAll('[data-tcc-results] [data-tcc-grid] > *').forEach((card) => {
            const node = document.importNode(card, true);
            added.push(node);
            frag.appendChild(node);
          });
          if (target) target.appendChild(frag);
          this.rebindTheme();
          this.notify('more', added);

          const end = doc.querySelector('[data-tcc-end]');
          const endEl = this.querySelector('[data-tcc-end]');
          if (end && endEl) endEl.textContent = end.textContent;

          const nextBtn = doc.querySelector('[data-tcc-load-more]');
          if (nextBtn) {
            const u = new URL(nextBtn.getAttribute('href'), location.origin);
            u.searchParams.delete('section_id');
            btn.href = u.pathname + u.search;
            btn.textContent = btn.dataset.label;
            btn.removeAttribute('aria-busy');
            if (this.observer) { this.observer.unobserve(btn); this.observer.observe(btn); }
          } else {
            if (this.observer) this.observer.disconnect();
            btn.remove();
          }
          return true;
        } catch (err) {
          url.searchParams.delete('section_id');
          location.href = url.toString();
          return false;
        }
      }

    });
  }

  if (!customElements.get('tcc-cp-slider')) {
    customElements.define('tcc-cp-slider', class extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-tcc-track]');
        if (!this.track) return;
        this.nav = this.querySelector('[data-tcc-nav]');
        this.prev = this.querySelector('[data-dir="-1"]');
        this.next = this.querySelector('[data-dir="1"]');
        this.current = this.querySelector('[data-tcc-current]');
        this.total = this.querySelector('[data-tcc-total]');

        this.onClick = (e) => {
          const b = e.target.closest('[data-dir]');
          if (!b) return;
          const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
          this.track.scrollBy({ left: Number(b.dataset.dir) * (this.track.clientWidth + gap) });
        };
        this.onScroll = () => {
          if (this.raf) return;
          this.raf = requestAnimationFrame(() => { this.raf = null; this.update(); });
        };
        this.addEventListener('click', this.onClick);
        this.track.addEventListener('scroll', this.onScroll, { passive: true });
        this.ro = new ResizeObserver(() => this.update());
        this.ro.observe(this.track);
        this.update();
      }

      disconnectedCallback() {
        if (!this.track) return;
        this.removeEventListener('click', this.onClick);
        this.track.removeEventListener('scroll', this.onScroll);
        if (this.ro) this.ro.disconnect();
        if (this.raf) cancelAnimationFrame(this.raf);
      }

      update() {
        const slides = this.track.children;
        if (!slides.length) return;
        const w = this.track.clientWidth;
        const perView = Math.max(1, Math.round(w / slides[0].getBoundingClientRect().width));
        const pages = Math.max(1, Math.ceil(slides.length / perView));
        const max = this.track.scrollWidth - w;
        const x = Math.abs(this.track.scrollLeft);
        const page = max <= 0 ? 1 : Math.min(pages, Math.round((x / max) * (pages - 1)) + 1);
        if (this.nav) this.nav.hidden = pages <= 1;
        if (this.current) this.current.textContent = page;
        if (this.total) this.total.textContent = pages;
        if (this.prev) this.prev.disabled = x <= 2;
        if (this.next) this.next.disabled = x >= max - 2;
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
